"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var common_1 = require("stremio/common");
var useMediaSession = function (videoState, player, fullscreen, onPlayRequested, onPauseRequested, onNextVideoRequested) {
    var shell = (0, common_1.usePlatform)().shell;
    (0, react_1.useEffect)(function () {
        if (!('audioSession' in navigator))
            return;
        var audioSession = navigator.audioSession;
        audioSession.type = fullscreen ? 'ambient' : 'playback';
        return function () {
            audioSession.type = 'playback';
        };
    }, [fullscreen]);
    // Playback state
    (0, react_1.useEffect)(function () {
        if (navigator.mediaSession) {
            var playbackState = !videoState.loaded || typeof videoState.paused !== 'boolean' ? 'none' : videoState.paused ? 'paused' : 'playing';
            navigator.mediaSession.playbackState = playbackState;
        }
        if (shell.active) {
            shell.send('media.status', {
                paused: !videoState.loaded || !!videoState.paused,
            });
        }
        return function () {
            if (navigator.mediaSession) {
                navigator.mediaSession.playbackState = 'none';
            }
        };
    }, [videoState.paused, videoState.loaded]);
    var shellActive = shell.active, shellSend = shell.send;
    (0, react_1.useEffect)(function () {
        return function () {
            if (shellActive) {
                shellSend('media.status', {
                    paused: true,
                });
            }
        };
    }, [shellActive, shellSend]);
    // Metadata
    (0, react_1.useEffect)(function () {
        var _a, _b, _c, _d, _e;
        var metaItem = player.metaItem && ((_a = player.metaItem) === null || _a === void 0 ? void 0 : _a.type) === 'Ready' ? player.metaItem.content : null;
        var videoId = player.selected ? (_d = (_c = (_b = player.selected) === null || _b === void 0 ? void 0 : _b.streamRequest) === null || _c === void 0 ? void 0 : _c.path) === null || _d === void 0 ? void 0 : _d.id : null;
        var video = metaItem === null || metaItem === void 0 ? void 0 : metaItem.videos.find(function (_a) {
            var id = _a.id;
            return id === videoId;
        });
        var videoInfo = (video === null || video === void 0 ? void 0 : video.season) && (video === null || video === void 0 ? void 0 : video.episode) ? " (".concat(video.season, "x").concat(video.episode, ")") : null;
        var videoTitle = video ? "".concat(video.title).concat(videoInfo) : null;
        var metaTitle = metaItem ? metaItem.name : null;
        var imageUrl = metaItem ? metaItem.logo : null;
        var title = videoTitle !== null && videoTitle !== void 0 ? videoTitle : metaTitle;
        var artist = (_e = (videoTitle && metaTitle)) !== null && _e !== void 0 ? _e : undefined;
        var artwork = imageUrl ? [{ src: imageUrl }] : undefined;
        if (title) {
            if (navigator.mediaSession) {
                navigator.mediaSession.metadata = new MediaMetadata({
                    title: title,
                    artist: artist,
                    artwork: artwork,
                });
            }
            if (shell.active) {
                shell.send('media.metadata', {
                    title: title,
                    artist: artist,
                    artUrl: imageUrl,
                });
            }
        }
    }, [player.metaItem, player.selected]);
    // Callbacks
    (0, react_1.useEffect)(function () {
        var mediaSession = navigator.mediaSession;
        if (!mediaSession)
            return;
        mediaSession.setActionHandler('play', onPlayRequested);
        mediaSession.setActionHandler('pause', onPauseRequested);
        mediaSession.setActionHandler('nexttrack', player.nextVideo ? onNextVideoRequested : null);
        return function () {
            mediaSession.setActionHandler('play', null);
            mediaSession.setActionHandler('pause', null);
            mediaSession.setActionHandler('nexttrack', null);
        };
    }, [player.nextVideo, onPlayRequested, onPauseRequested, onNextVideoRequested]);
    (0, react_1.useEffect)(function () {
        var onMediaStatus = function (_a) {
            var paused = _a.paused;
            paused ? onPauseRequested() : onPlayRequested();
        };
        shell.on('media.status', onMediaStatus);
        return function () {
            shell.off('media.status', onMediaStatus);
        };
    }, [shell, onPlayRequested, onPauseRequested]);
};
exports.default = useMediaSession;
